import { array, nonEmptyArray, option, record, string } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { Identifiable, Optional } from '@mews/std';
import { WithEnterpriseId } from '@mews-commander/types';

export const groupBySuperiorId =
    <T extends Identifiable>(grouping: (data: T) => string) =>
    (data: Optional<Array<T>>) =>
        pipe(
            data,
            option.fromNullable,
            option.flatMap(option.fromPredicate(array.isNonEmpty)),
            option.map(nonEmptyArray.groupBy<T>(grouping)),
            option.map(record.map(array.map(({ id }) => id))),
            option.getOrElse<Record<string, string[]>>(() => ({}))
        );

export const getDependentIds = (data: Record<string, string[]>) =>
    flow(
        array.map((id: string) => record.lookup(id, data)),
        array.compact,
        array.flatten
    );
export const checkIfSomeEntitiesAreFromSameEnterprise = <T extends WithEnterpriseId>(entities: T[]) =>
    pipe(
        entities.map((entity) => entity.enterpriseId),
        array.uniq(string.Eq),
        (enterpriseIds) => entities.length > enterpriseIds.length
    );
